import React from "react";
import { bookmarks2md } from "../Export";
import MDEditor from '@uiw/react-md-editor/nohighlight';

const MarkdownPreview = ({title, embedId, bookmark}) => {
    return (
        <MDEditor.Markdown source={bookmarks2md(title, embedId, bookmark)} />
      );
}

export default MarkdownPreview;